import { h } from 'preact'
import { MandatfordelingTable } from './MandatfordelingTable/MandatfordelingTable'
import { MandatTableItem } from '../../../shared/mandater'
import { Message } from '../../../../../lib/intl/Message'
import { Geografi } from '../../../../domain'
import styles from '../Mandatfordeling.css'

type Props = {
  items: MandatTableItem[]
  geografi: Geografi
  type: 'kommunestyre' | 'fylkesting'
}

export function DetaljertMandatfordeling(props: Props) {
  const { items, geografi, type } = props
  const navn = geografi.navn

  if (items.length > 0) {
    return (
      <div class={styles.detaljertMandatfordeling}>
        <MandatfordelingTable items={items} />
      </div>
    )
  }

  return (
    <p>
      <Message id={`${type}-ingen-resultat`} values={{ navn }} />
    </p>
  )
}
